import "./style.css";

const images = [
    {
        src: "/assets/images/MM.png",
        title: "Money Manager",
        subtitle: "A mobile solution to visualize and track the ins and outs of Money, inspired by mine and my friends struggle to keep track of our money.",
        category: "Shooting /",
        git: false,
        ext: true,
        extUrl: "https://play.google.com/store/apps/details?id=com.MoneyManagerPaskm.Money",
        stack: ["Ionic", "Capacitor", "Angular", "Typescript"]
    },
    {
        src: "/assets/images/OI.png",
        title: "Object Iterator",
        subtitle: "A JS module aiming to make development with objects easy, by proving a simple method to iterate over them",
        category: "Shooting /",
        git: true,
        ext: true,
        stack: ["Typescript"],
        extUrl: "https://www.npmjs.com/package/object-iter",
        gitUrl: "https://github.com/SfundoMhlungu/object-iter"
    },
    {
        src: "/assets/images/RM.png",
        title: "Suicide Checkers(min max)",
        subtitle: "An algorithms project for a client, basically two algorithms playing suicide checkers against each other(random and minmax algorithms)",
        category: "Shooting /",
        git: true,
        ext: false,
        gitUrl: "https://github.com/SfundoMhlungu/Suicide-Checkers-py.git",
        extUrl: "",
        stack: ["Python"]
  
    },
    {
      src: "/assets/images/DP.jpg",
      title: "Bot",
      subtitle: "A bot that can answer both programming and general questions, drawing from stackoverflow. ( the bot uses free heroku dynos- it may be down sometimes depending on availability of dynos,) the bot is available on telegram: DopeBot",
      category: "Shooting /",
      git: false,
      ext: false,
      gitUrl: "",
      extUrl: "",
      stack: ["Word2vec", "bayesian stats", "heroku","Python", "Tensorflow"]
  },
  {
    src: "/assets/images/Exitium.png",
    title: "Scroll Of Exitium",
    subtitle: "My first game : Final project for a game development specilization on Cousera, playable on itch.io",
    category: "Shooting /",
    git: false,
    ext: true,
    gitUrl: "",
    extUrl: "https://sfundosk.itch.io/exitium-scroll",
    stack: ["Unity Game Engine", "C#"]
  },
  
  {
    src: "/assets/images/TE.png",
    title: "Template Editor",
    subtitle: "A proposal project, basically an easier solution to templating emails, and sending them directly to users on a mobile app",
    category: "Shooting /",
    git: false,
    ext: false,
    gitUrl: "",
  
    extUrl: "", 
    stack: ["supabase", "express", "Vue", "Ionic", "Capacitor"]
  },
  ]
   
 interface Obj {
     src: string;
     title: string;
     subtitle: string;
     category: string;
     git: boolean;
     ext: boolean;
     gitUrl?: string;
     extUrl?: string; 
     stack: Array<any>
 }


 interface Prop{
    projecObj: any
 } 


  const Project:React.FC<Prop> = ({projecObj}) => {


    return (
      <div className="project" >
  
         <div className="img">
           <img src={projecObj.src}/>
  
         </div>
  
         <div className="text">
          <h2>{projecObj.title}</h2>
          <div className="description">
            <p>
              {projecObj.subtitle}
             </p>
          </div>
          <div className="stack">
             {projecObj.stack.map((el:any, index:any)=> (
               <li key={index}>{el}</li>
             ))}
          </div>
  
          <div className="links">
  
            { projecObj.git ? <li><a href={projecObj.gitUrl}><img src="/assets/images/github.png"></img></a></li> : ""}
            { projecObj.ext ?<li><a href={projecObj.extUrl}><img src="/assets/images/ext.png"></img></a></li> :""}
  
          </div>
         </div>
  
      </div>
    )
  }




const Gallery = () => {
    return(
   <div id="projects" data-scroll-section>
      <h1>PROJECTS</h1>

        <div>
        {images.map((p, i)=>(

        <Project projecObj={p} key={i}/>

        )

        )

        }
        </div>

   </div>
    )
}

export default Gallery